import React from "react";
import styled from "styled-components";

function getTagStyle(tag) {
  switch (tag) {
    case "h1":
      return "font-size: 36px;";
    case "h2":
      return "font-size: 32px;";
    case "h3":
      return "font-size: 24px;";
    case "h4":
      return "font-size: 18px;";
    case "h5":
      return "font-size: 16px;";
    case "h6":
      return "font-size: 14px;";
    default:
      return "font-size: 36px;";
  }
}

const StyledHeading = styled.h1`
  color: ${({ color }) => color || "white"};
  ${({ tagStyle }) => getTagStyle(tagStyle)}
`;

export const Heading = ({ as, tagStyle = as, color, ...props }) => {
  return (
    <StyledHeading as={as} tagStyle={tagStyle} color={color} {...props}>
      {props.children}
    </StyledHeading>
  );
};
